let language = {

    // 
    PC_RESOURCE_LIB_SET_SELECT_ALL_BTN: "全选",
    PC_RESOURCE_LIB_SET_CANCEL_ALL_BTN: "取消全选",
    PC_RESOURCE_LIB_SET_SELECTED_TITLE: "已选择：",
    PC_RESOURCE_LIB_SET_SAVE_BTN: "保存",
    
    PC_RESOURCE_LIB_SET_SEARCH_PLACEHOLDER: "搜索",
    
    // 
    // PC_RESOURCE_LIB_SET_MY_RESOURCE_TITLE: "我的",
    
};

export { language }
